// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.urn-page .urn-body {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.urn-hero__icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: linear-gradient(135deg, #7c3aed, #a78bfa);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
}

.urn-back-btn {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 1rem;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 10px;
  background: #fff;
  color: var(--text, #0f172a);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
}

.urn-back-btn:hover {
  background: #f8fafc;
}

.urn-empty {
  text-align: center;
  padding: 3rem 1.5rem;
  background: #fff;
  border-radius: 14px;
  border: 1px solid var(--border, #e2e8f0);
  color: var(--text-muted, #64748b);
}

.urn-empty i {
  font-size: 1.75rem;
  margin-bottom: 0.75rem;
  display: block;
}

.urn-empty--error {
  color: #dc2626;
}

.urn-empty--inline {
  padding: 2rem 1rem;
}

.urn-card {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 14px;
  padding: 1.25rem 1.5rem;
}

.urn-card__title {
  margin: 0 0 1rem;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text, #0f172a);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.urn-card__title i {
  color: #7c3aed;
}

.urn-card__hint {
  margin: -0.5rem 0 1rem;
  font-size: 0.85rem;
  color: var(--text-muted, #64748b);
}

.urn-user-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 0.85rem 1.25rem;
}

.urn-user-grid > div {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.urn-user-grid span {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted, #64748b);
}

.urn-user-grid strong {
  font-size: 0.9rem;
  color: var(--text, #0f172a);
}

.urn-user-grid code {
  font-size: 0.85rem;
  color: #7c3aed;
}

.urn-sponsor {
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px dashed var(--border, #e2e8f0);
}

.urn-sponsor h3 {
  margin: 0 0 0.65rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--text-muted, #64748b);
  text-transform: uppercase;
}

.urn-sponsor__box {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.85rem 1rem;
  background: #f5f3ff;
  border-radius: 10px;
  border: 1px solid #ddd6fe;
  font-size: 0.875rem;
}

.urn-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

.urn-stat {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 14px;
  padding: 1rem 1.15rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.urn-stat__label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted, #64748b);
}

.urn-stat__value {
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.2;
}

.urn-stat__sub {
  font-size: 0.8rem;
  color: var(--text-muted, #64748b);
}

.urn-stat--staking .urn-stat__value { color: #0f766e; }
.urn-stat--brokerage .urn-stat__value { color: #2563eb; }
.urn-stat--referral .urn-stat__value { color: #d97706; }
.urn-stat--combined .urn-stat__value { color: #7c3aed; }

.urn-level-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.75rem;
}

.urn-level-card {
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 10px;
  padding: 0.85rem;
  background: #f8fafc;
}

.urn-level-card__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.65rem;
  font-size: 0.8rem;
}

.urn-level-card__head span {
  font-weight: 600;
  color: #7c3aed;
}

.urn-earnings-mini {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem 0.75rem;
  font-size: 0.75rem;
  color: var(--text-muted, #64748b);
}

.urn-earnings-mini strong {
  color: var(--text, #0f172a);
  font-weight: 700;
}

.urn-earnings-mini i {
  margin-right: 0.2rem;
}

.urn-main-tabs,
.urn-subtabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.urn-main-tab,
.urn-subtab {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.6rem 1rem;
  border-radius: 10px;
  border: 1px solid var(--border, #e2e8f0);
  background: #fff;
  color: var(--text-muted, #64748b);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}

.urn-main-tab--active,
.urn-subtab--active {
  background: linear-gradient(135deg, #7c3aed, #a78bfa);
  border-color: transparent;
  color: #fff;
}

.urn-subtab__count {
  background: rgba(255, 255, 255, 0.25);
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  font-size: 0.7rem;
}

.urn-flow {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 0 1rem;
}

.urn-flow__root {
  width: 100%;
  display: flex;
  justify-content: center;
}

.urn-flow__node {
  min-width: 220px;
  max-width: 320px;
  padding: 1rem 1.25rem;
  border-radius: 14px;
  border: 2px solid #c4b5fd;
  background: linear-gradient(160deg, #f5f3ff 0%, #ede9fe 100%);
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.urn-flow__node--root {
  box-shadow: 0 8px 24px rgba(124, 58, 237, 0.15);
}

.urn-flow__node-badge {
  align-self: center;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  background: #7c3aed;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
}

.urn-flow__node-meta {
  font-size: 0.78rem;
  color: var(--text-muted, #64748b);
}

.urn-flow__node-code {
  font-size: 0.8rem;
  color: #7c3aed;
  margin-top: 0.15rem;
}

.urn-flow__connector {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.35rem 0;
}

.urn-flow__connector-line {
  width: 3px;
  height: 28px;
  background: linear-gradient(180deg, #a78bfa, #7c3aed);
  border-radius: 2px;
}

.urn-flow__connector-line--dashed {
  height: 16px;
  background: repeating-linear-gradient(
    180deg,
    #cbd5e1,
    #cbd5e1 4px,
    transparent 4px,
    transparent 8px
  );
}

.urn-flow__connector-arrow {
  color: #7c3aed;
  font-size: 0.75rem;
  margin-top: -2px;
}

.urn-flow__level {
  width: 100%;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 14px;
  padding: 1rem;
  background: #fff;
}

.urn-flow__level-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem 1rem;
  margin-bottom: 0.85rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #f1f5f9;
}

.urn-flow__level-pill {
  padding: 0.25rem 0.65rem;
  border-radius: 999px;
  background: #ede9fe;
  color: #6d28d9;
  font-size: 0.75rem;
  font-weight: 700;
}

.urn-flow__level-count {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text, #0f172a);
}

.urn-flow__members {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  justify-content: center;
}

.urn-flow__member {
  min-width: 120px;
  max-width: 150px;
  padding: 0.65rem 0.75rem;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
}

.urn-flow__member--more,
.urn-flow__member--less {
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--urn-teal, #0f766e);
  background: #f0fdfa;
  border: 1px dashed rgba(15, 118, 110, 0.35);
  cursor: pointer;
  font-family: inherit;
  transition: background 0.2s, border-color 0.2s, transform 0.15s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  min-height: 72px;
}

.urn-flow__member--more:hover,
.urn-flow__member--less:hover {
  background: #ccfbf1;
  border-color: var(--urn-teal, #0f766e);
  transform: translateY(-1px);
}

.urn-flow__member--more i,
.urn-flow__member--less i {
  font-size: 1rem;
  opacity: 0.85;
}

.urn-flow__member--less {
  color: #64748b;
  background: #f8fafc;
  border-color: #cbd5e1;
}

.urn-flow__member--less:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
  color: #475569;
}

.urn-flow__member-avatar {
  width: 34px;
  height: 34px;
  min-width: 34px;
  min-height: 34px;
  border-radius: 10px;
  background: linear-gradient(145deg, #0f766e, #14b8a6);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.02em;
}

.urn-flow__member-name {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text, #0f172a);
  line-height: 1.2;
  word-break: break-word;
}

.urn-flow__member-sub {
  font-size: 0.68rem;
  color: var(--text-muted, #64748b);
}

.urn-flow__empty {
  text-align: center;
  color: var(--text-muted, #64748b);
  padding: 1.5rem;
}

.urn-members-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;
}

.urn-member-card {
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}

.urn-member-card--open {
  border-color: rgba(15, 118, 110, 0.25);
  box-shadow: 0 4px 16px rgba(15, 118, 110, 0.08);
}

.urn-member-card__head {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem 1rem;
  border: none;
  background: #f8fafc;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
}

.urn-member-card__head:focus {
  outline: none;
}

.urn-member-card__head:focus-visible {
  outline: 2px solid #0f766e;
  outline-offset: 2px;
}

.urn-member-card__user {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.urn-member-card__avatar {
  width: 42px;
  height: 42px;
  min-width: 42px;
  min-height: 42px;
  border-radius: 12px;
  background: linear-gradient(145deg, #0f766e, #14b8a6);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.02em;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.2);
}

.urn-member-card__user strong {
  display: block;
  font-size: 0.9rem;
  color: var(--text, #0f172a);
}

.urn-member-card__user > div > span {
  display: block;
  font-size: 0.8rem;
  color: var(--text-muted, #64748b);
}

.urn-member-card__meta {
  font-size: 0.72rem !important;
  margin-top: 0.15rem;
}

.urn-member-card__summary {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.urn-member-card__body {
  padding: 1rem;
  border-top: 1px solid var(--border, #e2e8f0);
}

.urn-member-logs + .urn-member-logs {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px dashed var(--border, #e2e8f0);
}

.urn-member-logs h4 {
  margin: 0 0 0.65rem;
  font-size: 0.85rem;
  font-weight: 700;
}

.urn-member-logs h4 span {
  font-weight: 500;
  color: var(--text-muted, #64748b);
}

.urn-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 10px;
}

.urn-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
}

.urn-table th {
  padding: 0.65rem 0.85rem;
  text-align: left;
  font-weight: 600;
  color: var(--text-muted, #64748b);
  background: #f8fafc;
  border-bottom: 1px solid var(--border, #e2e8f0);
  white-space: nowrap;
}

.urn-table td {
  padding: 0.65rem 0.85rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: top;
}

.urn-table tbody tr:last-child td {
  border-bottom: none;
}

.urn-table--compact {
  font-size: 0.78rem;
}

.urn-table-user strong {
  display: block;
  font-size: 0.85rem;
}

.urn-table-user span {
  display: block;
  font-size: 0.75rem;
  color: var(--text-muted, #64748b);
}

.urn-badge {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: capitalize;
}

.urn-badge--staking {
  background: #dcfce7;
  color: #166534;
}

.urn-badge--brokerage {
  background: #dbeafe;
  color: #1d4ed8;
}

.urn-badge--referral {
  background: #fef3c7;
  color: #92400e;
}

.urn-muted {
  margin: 0;
  font-size: 0.85rem;
  color: var(--text-muted, #64748b);
}

@media (max-width: 1100px) {
  .urn-stats {
    grid-template-columns: repeat(2, 1fr);
  }

  .urn-level-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 720px) {
  .urn-stats,
  .urn-level-grid {
    grid-template-columns: 1fr;
  }

  .urn-member-card__head {
    flex-direction: column;
    align-items: flex-start;
  }

  .urn-member-card__summary {
    width: 100%;
    justify-content: space-between;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Traders/UserReferralNetworkPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA,sCAAsC,cAAc,EAAE;AACtD,wCAAwC,cAAc,EAAE;AACxD,uCAAuC,cAAc,EAAE;AACvD,uCAAuC,cAAc,EAAE;;AAEvD;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,qDAAqD;EACrD,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ;;;;;;GAMC;AACH;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,2CAA2C;EAC3C,eAAe;EACf,oBAAoB;EACpB,+DAA+D;EAC/D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;AACF","sourcesContent":[".urn-page .urn-body {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.urn-hero__icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #7c3aed, #a78bfa);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.35rem;\n}\n\n.urn-back-btn {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.55rem 1rem;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 10px;\n  background: #fff;\n  color: var(--text, #0f172a);\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.urn-back-btn:hover {\n  background: #f8fafc;\n}\n\n.urn-empty {\n  text-align: center;\n  padding: 3rem 1.5rem;\n  background: #fff;\n  border-radius: 14px;\n  border: 1px solid var(--border, #e2e8f0);\n  color: var(--text-muted, #64748b);\n}\n\n.urn-empty i {\n  font-size: 1.75rem;\n  margin-bottom: 0.75rem;\n  display: block;\n}\n\n.urn-empty--error {\n  color: #dc2626;\n}\n\n.urn-empty--inline {\n  padding: 2rem 1rem;\n}\n\n.urn-card {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 14px;\n  padding: 1.25rem 1.5rem;\n}\n\n.urn-card__title {\n  margin: 0 0 1rem;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text, #0f172a);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.urn-card__title i {\n  color: #7c3aed;\n}\n\n.urn-card__hint {\n  margin: -0.5rem 0 1rem;\n  font-size: 0.85rem;\n  color: var(--text-muted, #64748b);\n}\n\n.urn-user-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 0.85rem 1.25rem;\n}\n\n.urn-user-grid > div {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.urn-user-grid span {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-muted, #64748b);\n}\n\n.urn-user-grid strong {\n  font-size: 0.9rem;\n  color: var(--text, #0f172a);\n}\n\n.urn-user-grid code {\n  font-size: 0.85rem;\n  color: #7c3aed;\n}\n\n.urn-sponsor {\n  margin-top: 1.25rem;\n  padding-top: 1.25rem;\n  border-top: 1px dashed var(--border, #e2e8f0);\n}\n\n.urn-sponsor h3 {\n  margin: 0 0 0.65rem;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--text-muted, #64748b);\n  text-transform: uppercase;\n}\n\n.urn-sponsor__box {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  padding: 0.85rem 1rem;\n  background: #f5f3ff;\n  border-radius: 10px;\n  border: 1px solid #ddd6fe;\n  font-size: 0.875rem;\n}\n\n.urn-stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n}\n\n.urn-stat {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 14px;\n  padding: 1rem 1.15rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.urn-stat__label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-muted, #64748b);\n}\n\n.urn-stat__value {\n  font-size: 1.35rem;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.urn-stat__sub {\n  font-size: 0.8rem;\n  color: var(--text-muted, #64748b);\n}\n\n.urn-stat--staking .urn-stat__value { color: #0f766e; }\n.urn-stat--brokerage .urn-stat__value { color: #2563eb; }\n.urn-stat--referral .urn-stat__value { color: #d97706; }\n.urn-stat--combined .urn-stat__value { color: #7c3aed; }\n\n.urn-level-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 0.75rem;\n}\n\n.urn-level-card {\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 10px;\n  padding: 0.85rem;\n  background: #f8fafc;\n}\n\n.urn-level-card__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.65rem;\n  font-size: 0.8rem;\n}\n\n.urn-level-card__head span {\n  font-weight: 600;\n  color: #7c3aed;\n}\n\n.urn-earnings-mini {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem 0.75rem;\n  font-size: 0.75rem;\n  color: var(--text-muted, #64748b);\n}\n\n.urn-earnings-mini strong {\n  color: var(--text, #0f172a);\n  font-weight: 700;\n}\n\n.urn-earnings-mini i {\n  margin-right: 0.2rem;\n}\n\n.urn-main-tabs,\n.urn-subtabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.urn-main-tab,\n.urn-subtab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.6rem 1rem;\n  border-radius: 10px;\n  border: 1px solid var(--border, #e2e8f0);\n  background: #fff;\n  color: var(--text-muted, #64748b);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.urn-main-tab--active,\n.urn-subtab--active {\n  background: linear-gradient(135deg, #7c3aed, #a78bfa);\n  border-color: transparent;\n  color: #fff;\n}\n\n.urn-subtab__count {\n  background: rgba(255, 255, 255, 0.25);\n  padding: 0.1rem 0.45rem;\n  border-radius: 999px;\n  font-size: 0.7rem;\n}\n\n.urn-flow {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0.5rem 0 1rem;\n}\n\n.urn-flow__root {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.urn-flow__node {\n  min-width: 220px;\n  max-width: 320px;\n  padding: 1rem 1.25rem;\n  border-radius: 14px;\n  border: 2px solid #c4b5fd;\n  background: linear-gradient(160deg, #f5f3ff 0%, #ede9fe 100%);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.urn-flow__node--root {\n  box-shadow: 0 8px 24px rgba(124, 58, 237, 0.15);\n}\n\n.urn-flow__node-badge {\n  align-self: center;\n  padding: 0.15rem 0.55rem;\n  border-radius: 999px;\n  background: #7c3aed;\n  color: #fff;\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.urn-flow__node-meta {\n  font-size: 0.78rem;\n  color: var(--text-muted, #64748b);\n}\n\n.urn-flow__node-code {\n  font-size: 0.8rem;\n  color: #7c3aed;\n  margin-top: 0.15rem;\n}\n\n.urn-flow__connector {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0.35rem 0;\n}\n\n.urn-flow__connector-line {\n  width: 3px;\n  height: 28px;\n  background: linear-gradient(180deg, #a78bfa, #7c3aed);\n  border-radius: 2px;\n}\n\n.urn-flow__connector-line--dashed {\n  height: 16px;\n  background: repeating-linear-gradient(\n    180deg,\n    #cbd5e1,\n    #cbd5e1 4px,\n    transparent 4px,\n    transparent 8px\n  );\n}\n\n.urn-flow__connector-arrow {\n  color: #7c3aed;\n  font-size: 0.75rem;\n  margin-top: -2px;\n}\n\n.urn-flow__level {\n  width: 100%;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 14px;\n  padding: 1rem;\n  background: #fff;\n}\n\n.urn-flow__level-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.65rem 1rem;\n  margin-bottom: 0.85rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.urn-flow__level-pill {\n  padding: 0.25rem 0.65rem;\n  border-radius: 999px;\n  background: #ede9fe;\n  color: #6d28d9;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.urn-flow__level-count {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text, #0f172a);\n}\n\n.urn-flow__members {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n  justify-content: center;\n}\n\n.urn-flow__member {\n  min-width: 120px;\n  max-width: 150px;\n  padding: 0.65rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.2rem;\n}\n\n.urn-flow__member--more,\n.urn-flow__member--less {\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--urn-teal, #0f766e);\n  background: #f0fdfa;\n  border: 1px dashed rgba(15, 118, 110, 0.35);\n  cursor: pointer;\n  font-family: inherit;\n  transition: background 0.2s, border-color 0.2s, transform 0.15s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.35rem;\n  min-height: 72px;\n}\n\n.urn-flow__member--more:hover,\n.urn-flow__member--less:hover {\n  background: #ccfbf1;\n  border-color: var(--urn-teal, #0f766e);\n  transform: translateY(-1px);\n}\n\n.urn-flow__member--more i,\n.urn-flow__member--less i {\n  font-size: 1rem;\n  opacity: 0.85;\n}\n\n.urn-flow__member--less {\n  color: #64748b;\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.urn-flow__member--less:hover {\n  background: #f1f5f9;\n  border-color: #94a3b8;\n  color: #475569;\n}\n\n.urn-flow__member-avatar {\n  width: 34px;\n  height: 34px;\n  min-width: 34px;\n  min-height: 34px;\n  border-radius: 10px;\n  background: linear-gradient(145deg, #0f766e, #14b8a6);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: 0.02em;\n}\n\n.urn-flow__member-name {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text, #0f172a);\n  line-height: 1.2;\n  word-break: break-word;\n}\n\n.urn-flow__member-sub {\n  font-size: 0.68rem;\n  color: var(--text-muted, #64748b);\n}\n\n.urn-flow__empty {\n  text-align: center;\n  color: var(--text-muted, #64748b);\n  padding: 1.5rem;\n}\n\n.urn-members-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.urn-member-card {\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.urn-member-card--open {\n  border-color: rgba(15, 118, 110, 0.25);\n  box-shadow: 0 4px 16px rgba(15, 118, 110, 0.08);\n}\n\n.urn-member-card__head {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.85rem 1rem;\n  border: none;\n  background: #f8fafc;\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n  color: inherit;\n}\n\n.urn-member-card__head:focus {\n  outline: none;\n}\n\n.urn-member-card__head:focus-visible {\n  outline: 2px solid #0f766e;\n  outline-offset: 2px;\n}\n\n.urn-member-card__user {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.urn-member-card__avatar {\n  width: 42px;\n  height: 42px;\n  min-width: 42px;\n  min-height: 42px;\n  border-radius: 12px;\n  background: linear-gradient(145deg, #0f766e, #14b8a6);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8125rem;\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: 0.02em;\n  flex-shrink: 0;\n  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.2);\n}\n\n.urn-member-card__user strong {\n  display: block;\n  font-size: 0.9rem;\n  color: var(--text, #0f172a);\n}\n\n.urn-member-card__user > div > span {\n  display: block;\n  font-size: 0.8rem;\n  color: var(--text-muted, #64748b);\n}\n\n.urn-member-card__meta {\n  font-size: 0.72rem !important;\n  margin-top: 0.15rem;\n}\n\n.urn-member-card__summary {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.urn-member-card__body {\n  padding: 1rem;\n  border-top: 1px solid var(--border, #e2e8f0);\n}\n\n.urn-member-logs + .urn-member-logs {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px dashed var(--border, #e2e8f0);\n}\n\n.urn-member-logs h4 {\n  margin: 0 0 0.65rem;\n  font-size: 0.85rem;\n  font-weight: 700;\n}\n\n.urn-member-logs h4 span {\n  font-weight: 500;\n  color: var(--text-muted, #64748b);\n}\n\n.urn-table-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 10px;\n}\n\n.urn-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.82rem;\n}\n\n.urn-table th {\n  padding: 0.65rem 0.85rem;\n  text-align: left;\n  font-weight: 600;\n  color: var(--text-muted, #64748b);\n  background: #f8fafc;\n  border-bottom: 1px solid var(--border, #e2e8f0);\n  white-space: nowrap;\n}\n\n.urn-table td {\n  padding: 0.65rem 0.85rem;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: top;\n}\n\n.urn-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.urn-table--compact {\n  font-size: 0.78rem;\n}\n\n.urn-table-user strong {\n  display: block;\n  font-size: 0.85rem;\n}\n\n.urn-table-user span {\n  display: block;\n  font-size: 0.75rem;\n  color: var(--text-muted, #64748b);\n}\n\n.urn-badge {\n  display: inline-block;\n  padding: 0.2rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: capitalize;\n}\n\n.urn-badge--staking {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.urn-badge--brokerage {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.urn-badge--referral {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.urn-muted {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--text-muted, #64748b);\n}\n\n@media (max-width: 1100px) {\n  .urn-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .urn-level-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 720px) {\n  .urn-stats,\n  .urn-level-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .urn-member-card__head {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .urn-member-card__summary {\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
